import type { QuickAccessItem } from '../contexts/QuickAccessContext';

/**
 * Home "Recent apps" only surfaces plugins opened within this window. We have
 * `accessedAt` timestamps from QuickAccessContext (the same canonical recency
 * store the top-right launcher/search popup reads), so anything older than this
 * is treated as no longer "recent" and dropped from the section.
 */
export const RECENT_WINDOW_DAYS = 15;
export const RECENT_WINDOW_MS = RECENT_WINDOW_DAYS * 24 * 60 * 60 * 1000;

/**
 * Pure recency selector: given QuickAccess items, return navigation paths ordered
 * most-recent-first, dropping anything accessed before `nowMs - windowMs` or
 * lacking a usable timestamp.
 *
 * `excludePaths` removes apps already surfaced elsewhere on the Home grid
 * (specifically Favorites) so the Recent row never duplicates a pinned tile.
 */
export function selectRecentPaths(
  items: QuickAccessItem[],
  nowMs: number,
  windowMs: number = RECENT_WINDOW_MS,
  excludePaths?: ReadonlySet<string>,
): string[] {
  const cutoff = nowMs - windowMs;
  return items
    .filter(i => typeof i.accessedAt === 'number' && i.accessedAt >= cutoff)
    .filter(i => !excludePaths || !excludePaths.has(i.path))
    .sort((a, b) => b.accessedAt - a.accessedAt)
    .map(i => i.path);
}
